import React from 'react'
import CouponConfigurableLabel from '../CouponConfigurableLabel'


function TabButton(props: {text:string , numberOfSelectedItems?:number ,disabled?:boolean}) {

    const { text, numberOfSelectedItems, } = props

    return <div style={{ cursor: 'pointer'}}>
            <CouponConfigurableLabel text={text} style={{ cursor: 'pointer' , fontWeight:'600' ,color:'inherit' }} />
            {numberOfSelectedItems && numberOfSelectedItems > 0 ? <span style={{ marginLeft: '5px' }}>{`(${numberOfSelectedItems})`}</span>:<></>}
    </div>
}

export default React.memo(TabButton);